/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_History1Inputs */

const vi_cmstools_history1 = /** @type {(inputs: Cmstools_History1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử các lần đăng`)
};

/**

* @param {Cmstools_History1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_history1 = /** @type {((inputs?: Cmstools_History1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_History1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_history1(inputs)
});
export { cmstools_history1 as "cmsTools_history" }